import { useEffect, useState } from "react";
import { InputField, MainButton, Loader } from "commonUI";
import "./auth.css";
import { Logo } from "allIcons";
import { ApiResponseType } from "enums";
import { axiosInstance, useSearch, useUtilities } from "helpers";
import { useUserAuth } from "context/UserAuth";
import { useUserLogout } from "hooks/user";
import { t } from "i18next";

export default function ForgotPassword() {
  const {
    userAuth: { token },
  } = useUserAuth();
  const { navigate } = useUtilities();
  const { from } = useSearch();
  const [timer, setTimer] = useState(0);
  const [userInput, setUserInput] = useState({
    email: "",
    error: "",
    sucess: "",
  });
  const [loading, setLoading] = useState(false);
  const { mutate: logoutUser, isLoading } = useUserLogout(false);

  useEffect(() => {
    if (!token) return;
    if (from === "website") {
      logoutUser();
    } else {
      navigate("/");
    }
  }, [from, token, logoutUser, navigate]);

  useEffect(() => {
    let timerInterval = setInterval(() => {
      setTimer(timer - 1);
    }, 1000);
    if (timer === 0) {
      clearInterval(timerInterval);
    }
    return () => clearInterval(timerInterval);
  }, [timer]);

  function handleForget(e) {
    e.preventDefault();
    if (!userInput.email) {
      setUserInput({
        ...userInput,
        error: t("forgetPassword.error.emailRequired"),
        sucess: "",
      });
      return;
    }
    setLoading(true);
    axiosInstance
      .post(`forgetpassword`, {
        email: userInput.email,
      })
      .then((res) => res.data)
      .then((data) => {
        if (data.status_code === ApiResponseType.SUCCESS) {
          setUserInput({
            ...userInput,
            sucess: data.message,
            error: "",
          });
          setTimer(59);
        } else {
          setUserInput({
            ...userInput,
            error: t("forgetPassword.api.error.invalidEmail" ),
            sucess: "",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setUserInput({
          ...userInput,
          error: t("forgetPassword.api.error.invalidEmail" ),
          sucess: "",
        });
        setLoading(false);
      });
  }
  return (
    <>
      <Loader show={loading || isLoading} />
      <div className={`login-container`}>
        <div className="">
          <div
            className={`flex items-center bg-transparent mb-[87px] justify-center`}
          >
            <Logo className="logo-size" />
          </div>
          <div className="login-form">
            <h2 className="login-heading">{t("forgetPassword.title")}</h2>
            <p className="body-text forget-details">
              {t("forgetPassword.description")}
            </p>
            <div className="py-4 w-fit mx-auto">
              {userInput.error ? (
                <p className="error-text mb-1">{userInput.error}</p>
              ) : (
                userInput.sucess && (
                  <p className="success-text mb-1">{userInput.sucess}</p>
                )
              )}
              <InputField
                type="text"
                name="email"
                id="email_address"
                placeholder={t("forgetPassword.input.email.placeholder")}
                value={userInput.email}
                setValue={(value) =>
                  setUserInput({ ...userInput, email: value })
                }
                inputClass="py-1"
              />
              <div className="py-2">
                <MainButton onClick={handleForget} className={`w-full py-2 `}>
                  {t("forgetPassword.button.send")}
                </MainButton>
              </div>
              <div className="">
                <p className="signup-link">
                  {t("forgetPassword.emailNotReceived")}&nbsp;
                  <span
                    className={`forget-link cursor-pointer ${
                      timer ? "disabled" : ""
                    }`}
                    onClick={handleForget}
                  >
                    {timer
                      ? t("forgetPassword.button.resendInTime", {
                          timer,
                        })
                      : t("forgetPassword.button.resend")}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
